<template>
  <div>

    <b-form-group v-if="me_stesso" id="group-benefic-ben"
        label="Scegliere se il beneficiario è un proprio familiare oppure se stessi:"
        label-for="benefic-ben"
    >
      <b-form-radio-group
        id="benefic-ben"
        v-model="form_mode"
        :options="mode_options"
      ></b-form-radio-group>
    </b-form-group>

    <div v-if="show_form_familiare">

      <!-- Codice fiscale -->
      <b-form-group id="group-codfisc-ben"
        label="* Codice fiscale beneficiario:"
        label-for="codfisc"
        :invalidFeedback="invalid_cod_fisc_helptext"
        description="Inizia a scrivere il codice fiscale, se noti, ti saranno proposti i beneficiari già indicati in passato."
      >
        <b-form-input
          id="codfisc-forn"
          v-model="form.cod_fisc"
          maxlength="16"
          placeholder="Codice fiscale"
          type="text"
          list="codfisc-list"
          :state="form_state.cod_fisc"
          @keyup="onCodFiscKeyup"
          @change="onCodFiscChangeOrBlur"
          @blur="onCodFiscChangeOrBlur"
          @input="onCodFiscInput"
          required
        ></b-form-input>

        <datalist id="codfisc-list">
          <option v-for="(benefic, index) in benefic_datalist" :key="index">{{ benefic }}</option>
        </datalist>
      </b-form-group>

      <!-- Nome e Cognome -->
      <b-form-group id="group-nome-cognome-ben"
        label="* Nome e Cognome:"
        label-for="nome-cognome-ben"
        description="Indica il nome e cognome dell'effettivo beneficiario del bene o servizio"
      >
        <b-form-input
          id="nome-cognome-ben"
          v-model="form.nome"
          :state="form_state.nome"
          placeholder="Nome e Cognome"
          type="text"
          required
        ></b-form-input>
      </b-form-group>

      <!-- Relazione Parentale -->
      <b-form-group id="group-id-relazione"
        label="* Relazione parentale:"
        label-for="id-relazione"
      >
        <b-form-select id="id-relazione" v-model="form.id_relazione"
                        :options="relazioni_parentali"
                        :state="form_state.id_relazione"
                        required></b-form-select>
      </b-form-group>

      <!-- Modale per il caricamento dello stato di famiglia -->
      <b-form-group id="group-file-stato-famiglia"
          label="* Stato di famiglia, autocertificazione o carico fiscale">
        <!-- Modale per upload dello stato di famiglia -->
        <FileUploadModal :file_kind="modal_file_stato_famiglia.file_kind"
                         @fileIdReady="modal_file_stato_famiglia.doc_id = $event.doc_id"
                         @fileRemoved="modal_file_stato_famiglia.doc_id = null"/>
      </b-form-group>


    </div>
  </div>
</template>


<script>
import FileUploadModal from '@/components/FileUploadModal'
import { generalLib } from '@/generalLib'
import { apiUrl } from '@/apiUrl'
import axios from 'axios'

export default {
  name: 'FormBeneficiario',
  data () {
    return {
      // Modalità di visualizzazione del form.
      mode_options :  [
        { text: 'Un mio familiare', value: true },
        { text: 'Me stesso', value: false }
      ],

      // Datalist dei beneficiari trovati tramite la ricerca per codice fiscale
      benefic_datalist : [],

      // Modalidà di visualizzazione selezionata per il form
      form_mode : true,

      // Relazioni parentali selezionabili
      relazioni_parentali : [
        { value: null, text: "Seleziona un'opzione", disabled: true }
      ],

      // Stato dei dati del form per la validazione
      form_state : {
        cod_fisc : null,
        nome : null,
        id_relazione : null
      },

      // Dati del form
      form : {
        cod_fisc : null,
        nome : null,
        id_relazione : null
      },

      // Tipologia di documenti da far caricare con la modale di di upload file
      // e id del documento caricato tramite essa.
      modal_file_stato_famiglia : { file_kind : 'doc_fam', doc_id : null }

    }
  },
  computed : {
    /**
     * Se il codice fiscale non è corretto torna il testo
     * di help.
     */
    invalid_cod_fisc_helptext : function () {
      if ( this.form_state.cod_fisc === false ){
        return 'Codice fiscale errato';
      } else {
        return '';
      }
    },
    /**
     * Produce un flag che serve a far correttamente visualizzare
     * il form del beneficiario oppure no se il servizio è per me stesso.
     */
    show_form_familiare : function () {
        // Se il me_stesso non è abilitato faccio vedere solo il form del familiare
        if ( this.me_stesso === false ) {
          return true;
        } else {
          // Se il me stesso è abilitato il form del familiare è visibile sulla
          // base del flag form_mode, cioè della scelta fatta tramite radio button.
          if ( this.form_mode === true ) {
            return true;
          } else {
            return false;
          }
        }
    }
  },
  methods: {
    /**
     * Esegue la ricerca dei beneficiari per l'utente mentre si digita il
     * codice fiscale.
     */
    onCodFiscKeyup : function ( evt ) {

      // Facciamo partire la ricerca con almeno 2 caratteri
      if ( this.form.cod_fisc.length < 2 ) {
        return
      }

      let api_url = apiUrl.welfareapi.get_beneficiari.replace( '@cod_fisc', this.form.cod_fisc );
      axios.get( api_url )
      .then( ( response ) => {
        this.benefic_datalist = [];
        for ( let elem of response.data ){
          this.benefic_datalist.push( elem.cod_fisc );
        }
      })
      .catch( ( error ) => {
        console.error( error.response.data );
      });

    },
    /**
     * Rendiamo il codice fiscale sempre maiuscolo
     */
    onCodFiscInput : function ( evt ) {
      this.form.cod_fisc = this.form.cod_fisc.toUpperCase();
    },
    /**
     * Quando il codice fiscale noto viene selezionato, se lo stato è corretto,
     * andiamo a riempire tutti i campi del form.
     */
    onCodFiscChangeOrBlur : function ( evt ) {

      if ( this.form_state.cod_fisc === true ) {

        let api_url = apiUrl.welfareapi.get_beneficiari.replace( '@cod_fisc', this.form.cod_fisc );

        axios.get( api_url )
        .then( (response) => {

          // Siccome cerchiamo un codice fiscale noto e completo il dato
          // di ritorno deve essere un'array di un solo elemento, se non
          // è così c'è qualcosa che non va!
          if ( response.data.length > 1 ) {
            generalLib.backend_error_message_box( this, 'Impossibile trovare il beneficiario indicato.' );
            console.error( "Risultati multipli durante la ricerca del beneficiario noto." );
          } else {

            // Andiamo a compilare i campi, non serve una funzione di autofill
            // in quanto sono solo due campi che compilo e lascio poi liberi di
            // essere editati.
            this.form.nome = response.data[0].nome;
            this.form.id_relazione = response.data[0].id_relazione;
          }

        })
        .catch ( ( error ) => {
          console.error( error.response.data );
        });
      }
    },
    /**
     * Notifica al chiamante i nuovi dati tramtite l'emissione dell'evento
     * benDataChanged.
     */
    notifica_nuovi_dati : function () {

      // Andiamo a raggruppare i dati del form e li forniamo, inizialmente
      // lo stato invertito del flag show_form_familiare che ci fa capire
      // per chi stiamo facendo l'acquisto, se true è me_stesso, se false
      // è per un familiare.
      let data = { me_stesso : !this.show_form_familiare };

      // Aggiungiamo i dati del form con la desinenza '_ben' dopo il nome della chiave,
      // al codice fiscale applichiamo la trasformazione per rendere grandi tutte le
      // lettere
      for ( let key in this.form ) {
        let new_key = key + '_ben';
        data[ new_key ] = this.form[ key ];
      }

      if ( data[ 'cod_fisc_ben' ] !== null ) {
        data[ 'cod_fisc_ben' ] = data[ 'cod_fisc_ben' ].toUpperCase();
      }

      // Infine aggiungiamo i dati del file
      Object.assign( data, this.modal_file_stato_famiglia );

      this.$emit( 'benDataChanged', data );

    }
  },
  created : function () {
    /**
     * Alla creazione dell'elemento carico le relazioni parentali definite nel sistema
     * ed invoco subito la funzione notifica_nuovi_dati per dire subito al chiamante
     * quale è lo stato del flag me_stesso.
     */
    axios.get( apiUrl.welfareapi.relazioni_par )
    .then( ( response) => {
      for ( let elem of response.data ) {
        if ([2,3,4,8].includes(elem.id)){
          this.relazioni_parentali.push( { value: elem.id, text: elem.nome } );
        }
      }
    })
    .catch( ( error ) => {
      let mess = "Si è verificato un errore nel caricamento dei dati del form, " +
                 "non sarà possibile concludere correttamente la procedura. " +
                 "Tornare alla homepage e riprovare ad aprire il form. Se il problema persiste " +
                 "contattare l'assistenza."
      generalLib.backend_error_message_box( this, mess );
    })

    this.notifica_nuovi_dati();
  },
  watch : {
    /**
     * Controlliamo e validiamo il codice fiscale
     */
    'form.cod_fisc' : function ( val ) {
      if ( val === '' ) {
        this.form_state.cod_fisc = null;
      } else if ( generalLib.cod_fisc_is_valid( val ) ){
        this.form_state.cod_fisc = true;
      } else {
        this.form_state.cod_fisc = false;
      }
    },
    /**
     * Dobbiamo andare a notificare i nuovi dati anche se l'utente sceglie l'opzione me stesso
     * o un familiare.
     */
    show_form_familiare : function () {
      this.notifica_nuovi_dati();
    },
    /**
     * Quando passiamo dalla selezione dell'opzione un mio familiare a me stesso,
     * andiamo a ripulire il form e cancellare il documento allegato, soprattuto
     * quest'ultimo rimarrebbe nel sistema se l'utente non cambia poi ulteriormente
     * idea e deve quindi essere rimosso.
     */
    form_mode : function ( oldVal, newVal ) {

      if ( oldVal === false && newVal === true ) {
        this.form_state.cod_fisc = null;
        this.form_state.nome = null;
        this.form_state.id_relazione = null;
        this.form.cod_fisc = null;
        this.form.nome = null;
        this.form.id_relazione = null;
        // Reimposatimo a null anche un eventuale documento caricato.
        // La cancellazione del file avverà tramite la pulizia che esegue
        // il backend ogni volta che un nuovo file è caricato.
        this.modal_file_stato_famiglia.doc_id = null;
      }
    },
    /**
     * Solo in ultimo, dopo le validazioni, controlla la modifica dei campi del form e lo notifica al chiamante.
     * In questa versione con deep e l'handler andiamo a verificare lo stato
     * di tutto l'oggetto form:
     * https://stackoverflow.com/questions/42133894/vue-js-how-to-properly-watch-for-nested-data
     */
    form: {
      handler( val ){
        this.notifica_nuovi_dati();
      },
      deep: true
    },
    /**
     * La stessa cosa dobbiamo farla quando si hanno nuovi dati riguardo dal file che viene caricato
     */
    modal_file_stato_famiglia: {
      handler( val ){
        this.notifica_nuovi_dati();
      },
      deep: true
    },
    /**
     * Se viene passata la props preset_beneficiario allora andiamo a settare lo stato interno
     * del form con i dati ricevuti.
     * Per sapere come è fatto l'oggetto che deve essere passato alla props vedi documentazione
     * della props stessa.
     */
    preset_beneficiario : function () {
      this.form.cod_fisc = this.preset_beneficiario.cod_fisc;
      this.form.nome = this.preset_beneficiario.nome;
      this.form.id_relazione = this.preset_beneficiario.id_relazione_parentale;
    }
  },
  props : {
    /**
    * Indica se l'acquisto si può fare anche per se o solo per un componente della
    * famiglia. Se false l'acquisto si può fare solo per se, se true viene visualizzata
    * l'opportunità di scelta.
    */
    me_stesso: {
      type: Boolean,
      default : false
    },
    /**
     * Oggetto con i dati del beneficiario da passare per presettare con determinati
     * valori il form. Da passare solo se il beneficiario non sono io stesso,
     * In questo caso si passano i dati nel beneficiario nella forma:
     *  {
     *   "id_relazione_parentale": 3,
     *   "nome": "SAURO MARTA",
     *   "cod_fisc": "SRAMRT80A01A509T"
     *  }
     */
    preset_beneficiario: {
      type: Object,
      default : null
    }
  },
  components : {
    FileUploadModal
  }
}
</script>

<style scoped></style>